/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable import/no-extraneous-dependencies */
import { Html5Qrcode, Html5QrcodeScanner } from 'html5-qrcode';
import React, { useEffect, useRef } from 'react';
import { useActions } from '../../store/hooks/useActions';

const QRCodeScanner = ({ handleQRScan }) => {
  const html5QrCodeRef = useRef(null);
  const isScannerRunning = useRef(false);

  const { setToastError } = useActions();

  useEffect(() => {
    const html5QrCode = new Html5Qrcode('reader');
    html5QrCodeRef.current = html5QrCode;

    const startScanner = async () => {
      try {
        const devices = await Html5Qrcode.getCameras();
        if (!devices || devices.length === 0) {
          setToastError('No camera devices found.');
          console.error('No camera devices found.');
          return;
        }

        const cameraId = devices[0].id;

        await html5QrCode.start(
          cameraId,
          {
            fps: 10,
            qrbox: { width: 250, height: 250 },
            aspectRatio: 1.777
          },
          (decodedText) => {
            handleQRScan(decodedText);
          },
          () => {} // onScanFailure (optional)
        );

        isScannerRunning.current = true;
      } catch (err) {
        console.error('Camera access error:', err);
        if (err.name !== 'TypeError') {
          setToastError('Camera access error:');
        }
        handleQRScan();

        if (
          err.name === 'NotAllowedError' ||
          err.message?.includes('Permission')
        ) {
          window.alert(
            'Camera access denied. Please enable it in browser settings and reload.'
          );
        }
      }
    };

    startScanner();

    return () => {
      if (isScannerRunning.current && html5QrCodeRef.current) {
        html5QrCodeRef.current
          .stop()
          .then(() => {
            html5QrCodeRef.current.clear();
            isScannerRunning.current = false;
          })
          .catch((err) => console.error('Stop failed', err));
      }
    };
  }, []);

  // useEffect(() => {
  //   const scanner = new Html5QrcodeScanner(
  //     'reader',
  //     { fps: 10, qrbox: { width: 250, height: 250 } },
  //     false
  //   );

  //   scanner.render(
  //     (decodedText, decodedResult) => {
  //       console.log('Scanned:', decodedText);
  //     },
  //     (error) => {
  //       // console.warn("Error scanning", error);
  //     }
  //   );

  //   return () => scanner.clear();
  // }, []);

  return <div id='reader' style={{ width: '300px' }} />;
};

export default QRCodeScanner;
